import { makeStyles, tokens, shorthands } from '@fluentui/react-components';

export const useAppShellStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    height: '100dvh',
    overflow: 'hidden',
  },
  wallScreenRoot: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    height: '100dvh',
    width: '100vw',
    overflow: 'hidden',
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 9999,
    backgroundColor: '#010101',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    ...shorthands.padding(tokens.spacingVerticalS, tokens.spacingHorizontalL),
    rowGap: tokens.spacingVerticalS,
    backgroundColor: tokens.colorBrandBackground,
    color: tokens.colorNeutralForegroundOnBrand,
    flexShrink: 0,
    '@media (max-width: 768px)': {
      ...shorthands.padding(tokens.spacingVerticalS, tokens.spacingHorizontalM),
      minHeight: '64px',
      alignItems: 'center',
    },
  },
  headerTitle: {
    fontSize: tokens.fontSizeBase400,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForegroundOnBrand,
    textDecorationLine: 'none',
    whiteSpace: 'nowrap',
    '@media (max-width: 768px)': {
      fontSize: tokens.fontSizeBase300,
    },
  },
  // Mobile header row: burger | title (flex:1) | language selector
  mobileHeaderRow: {
    display: 'flex',
    alignItems: 'center',
    minHeight: '48px',
    width: '100%',
    columnGap: tokens.spacingHorizontalS,
  },
  mobileHeaderTitle: {
    flex: 1,
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForegroundOnBrand,
    textDecorationLine: 'none',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  burgerButton: {
    color: tokens.colorNeutralForegroundOnBrand,
    flexShrink: 0,
    minWidth: '44px',
    minHeight: '44px',
    ':hover': {
      backgroundColor: 'rgba(255,255,255,0.15)',
      color: tokens.colorNeutralForegroundOnBrand,
    },
  },
  nav: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    columnGap: tokens.spacingHorizontalS,
    rowGap: tokens.spacingVerticalXS,
    flexWrap: 'wrap',
  },
  navLink: {
    color: tokens.colorNeutralForegroundOnBrand,
    textDecorationLine: 'none',
    ...shorthands.padding(tokens.spacingVerticalS, tokens.spacingHorizontalM),
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    fontSize: tokens.fontSizeBase300,
    ':hover': {
      backgroundColor: 'rgba(255,255,255,0.15)',
    },
  },
  navLinkActive: {
    backgroundColor: 'rgba(255,255,255,0.2)',
    fontWeight: tokens.fontWeightSemibold,
  },
  navDivider: {
    width: '1px',
    height: '20px',
    backgroundColor: 'rgba(255,255,255,0.3)',
    marginLeft: tokens.spacingHorizontalS,
  },
  languageSelector: {},
  content: {
    flexGrow: 1,
    minHeight: 0,
    overflow: 'hidden',
  },

  // ── Sidebar (mobile) ────────────────────────────────────────────────────────
  navBackdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0,0,0,0.45)',
    zIndex: 999,
  },
  navSidebar: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '280px',
    height: '100vh',
    backgroundColor: tokens.colorNeutralBackground1,
    boxShadow: tokens.shadow28,
    zIndex: 1000,
    display: 'flex',
    flexDirection: 'column',
    transitionProperty: 'transform',
    transitionDuration: '230ms',
    transitionTimingFunction: 'ease-out',
    transform: 'translateX(-100%)',
  },
  navSidebarOpen: {
    transform: 'translateX(0)',
  },
  navSidebarHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    ...shorthands.padding(tokens.spacingVerticalM, tokens.spacingHorizontalM),
    backgroundColor: tokens.colorBrandBackground,
    flexShrink: 0,
  },
  navSidebarTitle: {
    fontSize: tokens.fontSizeBase400,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForegroundOnBrand,
  },
  navSidebarClose: {
    color: tokens.colorNeutralForegroundOnBrand,
    ':hover': {
      backgroundColor: 'rgba(255,255,255,0.15)',
      color: tokens.colorNeutralForegroundOnBrand,
    },
  },
  navSidebarLinks: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.padding(tokens.spacingVerticalS, 0),
    flexGrow: 1,
    overflowY: 'auto',
  },
  navSidebarLink: {
    display: 'block',
    ...shorthands.padding(tokens.spacingVerticalM, tokens.spacingHorizontalL),
    color: tokens.colorNeutralForeground1,
    textDecorationLine: 'none',
    fontSize: tokens.fontSizeBase400,
    ':hover': {
      backgroundColor: tokens.colorNeutralBackground1Hover,
    },
  },
  navSidebarLinkActive: {
    backgroundColor: tokens.colorNeutralBackground1Selected,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorBrandForeground1,
    borderLeftColor: tokens.colorBrandStroke1,
    borderLeftWidth: '3px',
    borderLeftStyle: 'solid',
  },
});